import { useQuery } from 'react-query'

import { ContactService } from '../services'
export interface ContactUploadStatus {
  successCount: number
  failedUploads: {
    executionName: string
    rowIndex: string
    status: string
    person: {
      firstName: string
      lastName: string
      mobilePhone: string
      email: string
      jobTitle: string
      linkedin: string
    }
    errors: {
      action: string
      namespace: string
      errorMessage: string
    }[]
  }[]
  importSize: number
  status: string
  terminated: boolean
}

export const useContactUploadStatus = (importId: number, refetchInterval: number | false) => {
  return useQuery<ContactUploadStatus>(
    ['contacts-upload-status', importId],
    () => ContactService.getContactUploadStatus(importId),
    { refetchInterval, refetchIntervalInBackground: true }
  )
}
